import { IClinicRoom, IOptionItem } from 'interfaces'
import { useEffect, useState } from 'react'
import { useClinicRoomService } from 'services'

const useClinicOptionRooms = (getDefaultInit = true) => {
  const [rooms, setRooms] = useState<Array<IClinicRoom>>([])
  const [optionRooms, setOptionRooms] = useState<Array<IOptionItem>>([])
  const [loading, setLoading] = useState(false)
  const { getClinicRooms } = useClinicRoomService()

  useEffect(() => {
    if (getDefaultInit) {
      handleGetClinicRooms()
    }
  }, [])

  const handleGetClinicRooms = () => {
    setLoading(true)
    getClinicRooms({ limit: 50, offset: 0, order_by: 'created_at' })
      .then((res) => {
        if (res?._successfully) {
          setRooms(res?.data || [])
          const options = res?.data?.map((item) => {
            return {
              label: item?.name,
              description: item?.doctor?.FullName,
              value: item?.id,
              doctorId: item?.doctor_id,
              data: item
            }
          })
          setOptionRooms(options)
        }
      })
      .finally(() => setLoading(false))
  }
  return { rooms, loading, optionRooms, getClinicRooms: handleGetClinicRooms }
}

export default useClinicOptionRooms
